export interface ServiceCaseCreateConfig {
    locale: string;
    env: string;
}
